<div class="profile-container">
  <div class="page-header">
    <h2>My Profile</h2>
    <p>View and manage your personal information</p>
  </div>

  <!-- Loading Spinner -->
  @if (isLoading) {
    <div class="loading-container">
      <div class="loading-content">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="loading-text">Loading profile...</p>
      </div>
    </div>
  } @else {
    <div class="table-container">
      @if (userDetails) {
        <!-- Profile Information Table -->
        <div class="profile-table">
          <table class="profile-data-table">
            <tbody>
              @for (item of profileData; track item.label) {
                <tr class="profile-row" [class.verified-row]="item.label === 'Verification Status' && userDetails.isVerified">
                  <td class="profile-label">
                    <mat-icon class="field-icon">{{ item.icon }}</mat-icon>
                    {{ item.label }}
                  </td>
                  <td class="profile-value">
                    @if (item.label === 'Verification Status' && userDetails.verificationStatus === 'verified') {
                      <div class="verified-status">
                        <mat-icon class="verified-icon">check_circle</mat-icon>
                        Verified
                      </div>
                    } @else if (item.label === 'Verification Status' && userDetails.verificationStatus === 'unvalidated') {
                      <div class="unverified-status">
                        <mat-icon class="unverified-icon">warning</mat-icon>
                        Pending manual verification
                      </div>
                    } @else {
                      {{ item.value }}
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <!-- Empty state -->
        <div class="empty-state-container">
          <div class="empty-state-content">
            <mat-icon class="empty-state-icon">person_off</mat-icon>
            <h3 class="empty-state-title">No Profile Information</h3>
            <p class="empty-state-message">
              Unable to load profile information. Please try logging in again.
            </p>
          </div>
        </div>
      }
    </div>
  }
</div>
